import React, { useRef } from 'react';
import styled, { css } from 'styled-components';
import { fontSize, standardColours, visuallyHidden } from '../../styles';

const StyledQuantityInput = styled.span`
  position: relative;
  display: block;

  ${({ $isCartItem }) => {
    if ($isCartItem) {
      return css`
        width: 120px;
        padding-left: 33px;
        padding-right: 33px;
      `;
    } else {
      return css`
        margin-top: 8px;
        padding-left: 53px;
        padding-right: 53px;
      `;
    }
  }}
`;

const StyledQuantityButton = styled.button`
  ${({ alt }) => (alt ? 'right: 0' : 'left: 0')};
  position: absolute;
  top: 0px;
  background: ${standardColours.lightestGrey};
  border: 1px solid ${standardColours.darkestGrey};

  &:before {
    content: ${({ alt }) => (alt ? '"+"' : '"-"')};
    ${fontSize(28)};
    line-height: ${({ alt }) => (alt ? '0.5' : '0.4')};
  }

  span {
    ${visuallyHidden()};
  }

  ${({ $isCartItem }) => {
    if ($isCartItem) {
      return css`
        min-width: 30px;
        min-height: 30px;
      `;
    } else {
      return css`
        min-width: 50px;
        min-height: 50px;
      `;
    }
  }}
`;

const StyledQuantity = styled.input`
  height: 50px;
  width: 100%;
  text-align: center;
  background-color: ${standardColours.white};
  border: 1px solid ${standardColours.darkestGrey};
  padding-bottom: 3px;
  -moz-appearance: textfield;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ${({ $isCartItem }) => {
    if ($isCartItem) {
      return css`
        height: 30px;
      `;
    } else {
      return css`
        height: 50px;
      `;
    }
  }}
`;

export const QuantityInput = ({
  name,
  quantity,
  setQuantity,
  maxQuantity,
  increment,
  isCartItem,
  ...props
}) => {
  const inputRef = useRef();

  const changeQuantity = value => {
    if (quantity) {
      if (value === 'remove') {
        setQuantity(quantity > increment ? quantity - increment : increment);
      } else if (value === 'add') {
        setQuantity(
          quantity === maxQuantity
            ? quantity
            : quantity
              ? quantity + increment
              : increment,
        );
      } else {
        setQuantity(parseInt(value));
      }
    } else {
      const currentValue = parseFloat(inputRef.current.value);

      if (value === 'remove') {
        inputRef.current.value = Math.max(currentValue - parseFloat(increment));
      } else if (value === 'add') {
        inputRef.current.value = currentValue + parseFloat(increment);
      }
    }
  };

  return (
    <StyledQuantityInput $isCartItem={isCartItem} {...props}>
      <StyledQuantityButton
        type="button"
        value="remove"
        onClick={e => changeQuantity(e.target.value)}
        $isCartItem={isCartItem}
      >
        <span>Remove One</span>
      </StyledQuantityButton>
      <StyledQuantity
        ref={inputRef}
        type="number"
        name={name}
        $isCartItem={isCartItem}
        {...(quantity
          ? {
              value: quantity,
            }
          : {
              defaultValue: 1,
            })}
        min="1"
        max={maxQuantity}
        step={increment}
        onChange={e => changeQuantity(e.target.value)}
        required
        readOnly
      />
      <StyledQuantityButton
        type="button"
        value="add"
        alt={true}
        onClick={e => changeQuantity(e.target.value)}
        $isCartItem={isCartItem}
      >
        <span>Add One</span>
      </StyledQuantityButton>
    </StyledQuantityInput>
  );
};
